/* eslint-disable @angular-eslint/prefer-standalone */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'address',
  standalone: false
})
export class AddressPipe implements PipeTransform {
  transform(value: string, type: string): string {
    let addressNumber = '';
    switch (type) {
      case 'A':
        return value.includes(',') ? value.replace(/(.+)+[,]+(.+)/, '$1') : value;
      case 'N':
        addressNumber = value.includes(',') ? value.replace(/(.+)+[,]+(.+)/, '$2'): '';
        return addressNumber.trim();
      default:
        return value;
    }
  }
}
